import React, { useContext } from 'react';
import { Divider } from '@nextiva/next-ui-components';

import { SvgKey } from 'components/SvgIcon';

import { RemoveLicense } from '../RemoveLicense';
import { UserContext } from '../../../../usersContext';
import { UserDrawerContext } from '../../../../UserDrawerContent/UserDrawerContext';

import dividerClasses from './LicenseRows.scss';

const displayLicenceName = (license) => {
  if (
    (license?.license_definition || license?.licenseDefinition)?.name.includes(
      'NUC-',
    )
  ) {
    return (
      license?.license_definition?.description ||
      license?.licenseDefinition?.description
    );
  }
  return license?.license_definition?.name || license?.licenseDefinition?.name;
};

const LicenseRows = () => {
  const {
    userState: { isLicensesLoading },
  } = useContext(UserContext);
  const {
    userDrawerState: { assignedLicenses, licensesToAdd },
  } = useContext(UserDrawerContext);

  return (
    <div
      className="m-user-edit-drawer-section__licenseList"
      data-testid="PlatformAdminUI-UsersLink-LicenseRow-LicenseList"
    >
      <Divider className={dividerClasses.topRoot} />
      {!isLicensesLoading &&
        assignedLicenses.map((license) => {
          return (
            <div key={license.id}>
              <div className="m-user-edit-drawer-section__licenseRow">
                <SvgKey />
                <div
                  className="m-user-edit-drawer-section__licenseRow__text"
                  data-testid="PlatformAdminUI-UsersLink-LicenseRow-LicenseListText"
                >
                  {displayLicenceName(license)}
                </div>
                <RemoveLicense license={license} />
              </div>
              <Divider className={dividerClasses.root} />
            </div>
          );
        })}
      {!isLicensesLoading &&
        licensesToAdd.map((license) => {
          return (
            <div key={license.id}>
              <div className="m-user-edit-drawer-section__licenseRow">
                <SvgKey />
                <div className="m-user-edit-drawer-section__licenseRow__text">
                  {displayLicenceName(license)}
                </div>
                <RemoveLicense license={license} />
              </div>
              <Divider className={dividerClasses.root} />
            </div>
          );
        })}
    </div>
  );
};

export default LicenseRows;
